"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommentMessage = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var MentionUtilities_1 = require("../MentionUtilities");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var urlRegex = /(?:http|ftp|https):\/\/(?:[\w_-]+(?:(?:\.[\w_-]+)+))(?:[\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?/;
var mentionRegex = /{{\$\$mention:.*?}}/;
var mentionNameRegex = /{{\$\$mention:(.*?)}}/;
var separatorRegex = new RegExp("(".concat(urlRegex.source, "|").concat(mentionRegex.source, ")"), "g");
var CommentMessage = (0, mobx_react_1.observer)(function (_a) {
    var mentions = _a.mentions, message = _a.message, usersInAccount = _a.usersInAccount, pendingUsers = _a.pendingUsers;
    var templatedMessage = (0, MentionUtilities_1.mergeMentionsAndMessageForDisplay)(mentions || [], message, usersInAccount, pendingUsers);
    var messageInParts = templatedMessage.split(separatorRegex);
    return (react_1.default.createElement("div", { className: "comment-message" }, messageInParts.map(function (part, idx) {
        return renderMention(part, idx) || renderLink(part, idx) || react_1.default.createElement(react_1.default.Fragment, { key: idx }, part);
    })));
});
exports.CommentMessage = CommentMessage;
function renderMention(part, idx) {
    var mentionMatch = part.match(mentionNameRegex);
    var partIsMention = Boolean(mentionMatch);
    if (partIsMention) {
        var displayName = mentionMatch ? mentionMatch[1] : "";
        return (react_1.default.createElement("span", { key: idx, className: "comment-message__mention" },
            "@",
            displayName));
    }
    else {
        return null;
    }
}
function renderLink(part, idx) {
    var isLink = part.search(urlRegex) !== -1;
    if (isLink) {
        return (react_1.default.createElement(kaleidoscope_1.Link, { key: idx, href: part, target: "_blank", rel: "noopener noreferrer" }, part));
    }
    else {
        return null;
    }
}
